<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.qe_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="qc_macode">
            <label class="weui-form-preview__label">{{customLabel.qc_macode || "工单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_macode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_ma_qty">
            <label class="weui-form-preview__label">{{customLabel.qc_ma_qty || "工单数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_ma_qty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qe_prodcode">
            <label class="weui-form-preview__label">{{customLabel.qe_prodcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qe_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qe_prodname">
            <label class="weui-form-preview__label">{{customLabel.qe_prodname || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qe_prodname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_custname">
            <label class="weui-form-preview__label">{{customLabel.qc_custname || "客户名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_date">
            <label class="weui-form-preview__label">{{customLabel.qc_date || "日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.qc_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_process">
            <label class="weui-form-preview__label">{{customLabel.qc_process || "工序"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_process
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_work_class">
            <label class="weui-form-preview__label">{{customLabel.qc_work_class || "班次"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_work_class
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_person">
            <label class="weui-form-preview__label">{{customLabel.qc_person || "生产负责人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_person
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">检验信息</div>
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">检验数量</label>
            <span class="weui-form-preview__value">{{ form.main.qc_qty }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良品数</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_ng_qty
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">直通率目标</label>
            <span class="weui-form-preview__value"
              >{{ form.main.qc_ok_rate }}%</span
            >
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">QC异常单号</label>
            <span class="weui-form-preview__value">{{
              form.main.qe_qccode
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">QC检验结果</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_result
            }}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">原因分析</div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items1"
          :key="index"
        >
          <div class="form-detail-preview_num">{{ index + 1 }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良现象</label>
            <span class="weui-form-preview__value">{{
              item.qed_nk_reason
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{ item.qed_qty }}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">趋势</label>
            <span class="weui-form-preview__value"
              >{{}}</span
            >
          </div> -->
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">原因分析</label>
            <span class="weui-form-preview__value">{{ item.qed_reason }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">
          <span>临时纠正及改善措施</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="add('临时')"
            v-if="!readonly"
          >
            <span>添加</span>
          </a>
        </div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items2"
          :key="index"
        >
          <div class="form-detail-preview_num">{{ index + 1 }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">姓名</label>
            <span class="weui-form-preview__value">{{ item.creatorName }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">时间</label>
            <span class="weui-form-preview__value">{{ item.createTime }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">临时纠正及改善措施</label>
            <span class="weui-form-preview__value">{{ item.qm_context }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">
          <span>长期纠正及改善措施</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="add('长期')"
            v-if="!readonly"
          >
            <span>添加</span>
          </a>
        </div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items3"
          :key="index"
        >
          <div class="form-detail-preview_num">{{ index + 1 }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">姓名</label>
            <span class="weui-form-preview__value">{{ item.creatorName }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">时间</label>
            <span class="weui-form-preview__value">{{ item.createTime }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">临时纠正及改善措施</label>
            <span class="weui-form-preview__value">{{ item.qm_context }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">
          <span>结果追踪及验证</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="add('结果')"
            v-if="!readonly"
          >
            <span>添加</span>
          </a>
        </div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items4"
          :key="index"
        >
          <div class="form-detail-preview_num">{{ index + 1 }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">姓名</label>
            <span class="weui-form-preview__value">{{ item.creatorName }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">时间</label>
            <span class="weui-form-preview__value">{{ item.createTime }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">临时纠正及改善措施</label>
            <span class="weui-form-preview__value">{{ item.qm_context }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mark" v-if="pindex != -1">
      <div class="page page__has-bar">
        <div class="page__bd">
          <div class="weui-cells__group textarea-cell">
            <div class="weui-cells__title">添加内容</div>
            <div class="weui-cells">
              <div class="weui-cell">
                <div class="weui-cell__bd">
                  <textarea
                    class="weui-textarea"
                    placeholder="请输入内容"
                    rows="3"
                    v-model="data.qm_context"
                    maxlength="300"
                  ></textarea>
                  <div class="weui-textarea-counter">
                    <span>{{
                      data.qm_context ? data.qm_context.length : 0
                    }}</span
                    >/300
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex weui-dialog__ft">
          <a
            href="javascript:;"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click="determine()"
            >确定</a
          >
          <a
            href="javascript:;"
            class="weui-dialog__btn weui-dialog__btn_default"
            @click="() => (pindex = -1)"
            >取消</a
          >
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="readonly">
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
      ></share>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import Share from "@/components/button/Share.vue";

export default {
  mixins: [form],
  components: {
    Share,
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/qc/makeQe/",
      caller: "MakeQe",
      xtype: "qc-makeqe-formpanel",
      pindex: -1,
      data: {
        qm_class: "",
        qm_context: null,
        qm_qecode: "",
        qm_qeid: "",
      },
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.qe_code,
        bizType: "MakeQe",
        bizId: main.id,
        viewType: "qc-makeqe-formpanel",
        title: "QE分析单" + main.qe_code,
      };
    },
  },
  methods: {
    add(type) {
      var me = this,
        main = me.form.main;
      me.data.qm_context = null;
      me.data.qm_class = type;
      me.data.qm_qecode = main.qe_code;
      me.data.qm_qeid = main.id;
      me.pindex = 0;
    },
    determine() {
      var me = this,
        qm_context = me.data.qm_context;
      if (qm_context) {
        me.$loading({
          url: "/api/qc/makeQe/addQeMeasure",
          method: "POST",
          jsonData: me.data,
        }).then(function (res) {
          if (res.success) {
            me.$weui.toast("保存成功", 2000);
            me.pindex = -1;
            me.f_get();
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        });
      } else {
        me.$weui.topTips("请输入内容", 2000);
      }
    },
  },
};
</script>

<style scoped>
.mark {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 500;
  overflow-y: scroll;
}
.header-tool {
  font-size: 12px;
}
.flex a{
  text-align: center;
  border-bottom:1px solid #F5F5F5;
}
</style>